import {
    Component,
    Inject,
    OnDestroy,
    OnInit,
    TemplateRef
} from '@angular/core';

//service 
import {
    OnlineUsersService
} from "../../services/onlineUsers.service";
import {
    LocalizePipe
} from "../../pipes/Localize.pipe";

// data Models
import {
    IErrorHandlerToken,
    IErrorHandler,
    FilterCriteria
} from "../../dataModels";
import {
    Configuration
} from '../../configurations/shared.config';
import {
    Subscription
} from 'rxjs';
import {
    BsModalRef,
    BsModalService
} from 'ngx-bootstrap';

@Component({
    selector: 'app-online-users-counter',
    templateUrl: 'OnlineUsers.component.html',
    styleUrls: ['OnlineUsers.component.scss']
})
export class onlineUsersComponent implements OnInit, OnDestroy {
    onlineUsersNo: number = 0;
    onlineUserList: any[] = [];
    signalRSubscriptions: Subscription;
    modalRef: BsModalRef;
    staffFilter: FilterCriteria;
    constructor(
        private onlineUsersService: OnlineUsersService,
        @Inject(IErrorHandlerToken) private errorHandler: IErrorHandler,
        private localizer: LocalizePipe,
        private modalService: BsModalService) {}

    ngOnInit() {
        this.getOnlineUsers();
        this.onUserStatusChange();
        this.staffFilter = new FilterCriteria;
    }

    onUserStatusChange() {
        this.signalRSubscriptions = this.onlineUsersService.receiveUserStatus().subscribe(res => {
            this.getOnlineUsers();
        });
    }

    getOnlineUsers(loader: boolean = true) {
        this.onlineUsersService.getOnlineUsers(loader).subscribe(res => {
            if (!res.IsErrorState) {
                this.onlineUsersNo = res.Value;
            } else {
                this.errorHandler.Handle(this.localizer.transform(Configuration.messages.defaultErrorMessage));
            }
        })
    }

    openOnlineUderDetailsPopup(template: TemplateRef < any > ) {
        this.modalRef = this.modalService.show(template, {
            //class: 'modal-sm',
            backdrop: 'static',
            keyboard: false
        });
        this.getOnlineUderDetails();


    };


    getOnlineUderDetails() {
        this.staffFilter.PageNumber = -1;
        this.staffFilter.PageSize = 0;
        this.staffFilter.PageCriteria = {
            PageNumber: -1,
            PageSize: 0
        }
        this.onlineUsersService.getStaff(this.staffFilter).subscribe(res => {
            if (!res.IsErrorState) {
                //console.log("getOnlineUderDetails", res.Value.Collection);
              //  console.log("filtered getOnlineUderDetails", res.Value.Collection.filter(driver => driver.OnlineStatus === true));
                //this.vehiclesDetailsResponse = res;
                this.onlineUserList = res.Value.Collection.filter(driver => driver.OnlineStatus === true);

                for (let driver of this.onlineUserList) {
                    this.onlineUsersService.GetUserDetails(driver.Id).subscribe(res => {
                        if (!res.IsErrorState) {
                          //  console.log("GetUserDetails", res.Value.BranchId);
                            driver.BranchId = res.Value.BranchId;

                            this.onlineUsersService.GetBranchDetails(driver.BranchId).subscribe(res => {
                                if (!res.IsErrorState) {
                                    driver.BranchName = res.Value.Name;
                                  //  console.log("driver", driver);
                                  //  console.log("this.onlineUserList", this.onlineUserList);
                                } else {
                                    this.errorHandler.Handle(this.localizer.transform(Configuration.messages.defaultErrorMessage));
                                }
                            })
                        } else {
                            this.errorHandler.Handle(this.localizer.transform(Configuration.messages.defaultErrorMessage));
                        }
                    })
                }

            } else {
                this.errorHandler.Handle(this.localizer.transform(Configuration.messages.defaultErrorMessage));
            }
        })
    }

    closePopup() {
        this.onlineUserList = [];
        this.modalRef.hide();
    }
    ngOnDestroy() {

        this.signalRSubscriptions.unsubscribe();
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/OnlineUsers/OnlineUsers.component.ts